import * as React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import {
    SingleScoreBox,
    SingleScoreBoxItem,
    SingleScoreItem,
    SingleScoreWrapper,
} from 'src/domains/sportsbook/webview/components/events/row/Score.style';
import { observer } from 'src/utils/mobx-react';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';

interface ScorePropsType {
    smallEvent: EventListGroupEventItemType;
    dataTest?: string;
}

export const SingleScore = observer('SingleScore', (props: ScorePropsType) => {
    const { smallEvent, dataTest } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const eventModel = smallEvent.id2.getEventModel();

    if (
        eventModel === null ||
        eventModel.timeSettingsStarted === false ||
        eventModel.scoreHome === null ||
        eventModel.scoreAway === null
    ) {
        return null;
    }

    const { scoreHome, scoreAway } = eventModel;

    if (configState.componentVariants.singleScoreVariant === DefaultComponentVariantType.PRIMARY) {
        return (
            <SingleScoreWrapper data-test={dataTest ?? 'single-score'}>
                <SingleScoreItem>{scoreHome}</SingleScoreItem>
                <SingleScoreItem>{scoreAway}</SingleScoreItem>
            </SingleScoreWrapper>
        );
    }

    return (
        <SingleScoreBox data-test={dataTest ?? 'single-score'}>
            <SingleScoreBoxItem>{scoreHome}</SingleScoreBoxItem>
            <SingleScoreBoxItem>{scoreAway}</SingleScoreBoxItem>
        </SingleScoreBox>
    );
});
